import type {IAppState} from './model'

export function hideOfflineWarning ({
    app,
    persist,
    dismiss,
}: {
    app: IAppState
    persist: (app: IAppState) => void
    dismiss: () => void
}) {
    app.settings.offlineWarn = false
    persist(app)
    dismiss()
}
